import React from 'react';
import ClickablePaper from '../../../Clinics/ModifyClinic/components/tabs/ClinicConditionsTab/ClickablePaper.styled';
import { MasterMedicine } from '../../../../apis/master-medicines/types';
import { VirtualMedicine as IVirtualMedicine } from '../../../../apis/virtual-medicines/types';

interface Props {
  masterMedicine: MasterMedicine;
  medicine: IVirtualMedicine;
  onClick: () => void;
}

const ClickableVirtualMedicine = ({ onClick, medicine, masterMedicine }: Props) => {
  return (
    <ClickablePaper onClick={onClick}>
      {masterMedicine.name} {medicine.strength}/{medicine.size} {medicine.form}
    </ClickablePaper>
  );
};

export default ClickableVirtualMedicine;
